import styled from 'styled-components';

export const StyledSettingsDropdown = styled.div`
  background: ${props => props.theme.themeColors.settingsDropdown.background};
  border-radius: 4px;
  border: 0.5px solid
    ${props => props.theme.themeColors.settingsDropdown.borderColor};
  box-shadow: ${props => props.theme.themeColors.settingsDropdown.boxShadow};
  display: flex;
  flex-direction: column;
  height: auto;
  opacity: ${props => (props.isOpened ? '1' : '0')};
  position: fixed;
  right: 32px;
  top: 72px;
  transition: visibility 0.3s, opacity 0.3s ease;
  visibility: ${props => (props.isOpened ? 'visible' : 'hidden')};
  width: 352px;
  z-index: 2000;

  &:before,
  &:after {
    bottom: 100%;
    content: '';
    display: block;
    height: 0;
    position: absolute;
    width: 0;
  }

  &:before {
    border: 11px solid transparent;
    border-bottom-color: ${props =>
      props.theme.themeColors.settingsDropdown.borderColor};
    right: 29px;
  }
  &:after {
    border: 10px solid transparent;
    border-bottom-color: ${props =>
      props.theme.themeColors.settingsDropdown.background};
    right: 30px;
  }
`;

export const StyledThemeToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;

  > span {
    color: ${props => props.theme.themeColors.settingsDropdown.textColor};
    font-size: 14.22px;
  }
`;

export const ThemeButton = styled.button`
  border: ${props =>
    props.active ? `3px solid ${props.theme.genericColors.orangeSoft}` : 0};
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: 36px;

  &:not(:last-child) {
    margin-right: 12px;
  }
`;

export const LightThemeButton = styled(ThemeButton)`
  background: ${props => props.theme.genericColors.white};
  border: ${props =>
    !props.active && `1px solid ${props.theme.genericColors.grayLight}`};
`;

export const YellowThemeButton = styled(ThemeButton)`
  background: ${props => props.theme.genericColors.sidecarYellow};
`;

export const GrayThemeButton = styled(ThemeButton)`
  background: ${props => props.theme.genericColors.grayBoulder};
`;

export const DarkThemeButton = styled(ThemeButton)`
  background: ${props => props.theme.genericColors.blackMineShaft};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
`;

export const StyledOldReaderWrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: 14.22px;
  padding: 20px 0 20px 24px;

  > a {
    color: ${props =>
      props.theme.themeColors.settingsDropdown.oldReaderLinkColor};
    margin: 0;
    padding: 0;
    text-decoration: none;

    &:hover {
      color: ${props =>
        props.theme.themeColors.settingsDropdown.oldReaderLinkColorOnHover};
    }
  }
`;

export const StyledPageControlsWrapper = styled.div`
  border-top: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor};
  display: flex;
  height: 72px;
  width: 100%;
`;

export const StyledControlButton = styled.button`
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: 88px;
`;

export const StyledRotateButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledAdjustByHeightButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledAdjustByWidthButton = styled(StyledControlButton)`
  border-right: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor}; ;
`;

export const StyledFullscreenStartButton = styled(StyledControlButton)``;

export const StyledDivider = styled.hr`
  border: 0.5px solid
    ${props => props.theme.themeColors.settingsDropdown.dividerColor};
  margin-bottom: 0;
  margin-top: 0;
  width: calc(100% - 48px);
`;

export const StyledToggleSinglePageModeWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1.125em 1.5em;

  > span {
    color: ${props => props.theme.themeColors.settingsDropdown.textColor};
    font-size: 14.22px;
  }
`;

export const PageModeButton = styled.button.attrs({ type: 'button' })`
  align-items: center;
  appearance: none;
  background: ${props => props.theme.themeColors.settingsDropdown.background};
  border: 1px solid
    ${props => props.theme.themeColors.settingsDropdown.pageModeTogglerBorder};
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 36px;

  & rect {
    fill: ${props => props.active && props.theme.genericColors.orangeSoft};
  }

  &:hover {
    & rect {
      fill: ${props => props.theme.genericColors.orangePeachy};
    }
  }

  &:focus {
    outline: 2px solid ${props => props.theme.genericColors.blueSoft};
  }

  &:active {
    & rect {
      fill: ${props => props.theme.genericColors.orangeSoft};
    }
  }

  &:not(:last-child) {
    margin-right: 16px;
  }
`;
